import React from 'react'
import { useTranslation } from 'react-i18next'

import { Accordion, AccordionTab } from 'primereact/accordion'
import { Message } from 'primereact/message'

import { isItemInitial } from '../../../../../utils/helper/checkConfirmationCodes'
import { useAllDeliveryForecastDespatchAdviceItems } from '../../../data'
import { Position } from './Position'

type Props = {
  despatchAdviceId: string
}

export const Overview: React.FC<Props> = ({ despatchAdviceId }) => {
  const { t } = useTranslation()
  const { data: deliveryForecastDespatchAdviceItems } =
    useAllDeliveryForecastDespatchAdviceItems(despatchAdviceId)

  const createDynamicTabs = () => {
    const onlyOneItem = deliveryForecastDespatchAdviceItems?.length === 1

    return deliveryForecastDespatchAdviceItems?.map(item => {
      return (
        <AccordionTab
          key={item.BuyerProductId}
          header={t(
            'deliveryForecastDespatchAdvice.title.send.dialog.shedules.positions.title',
            {
              position: item.DesAdvPosition,
            },
          )}
          disabled={onlyOneItem}
        >
          {/* @ts-ignore */}
          <Position despatchAdviceId={despatchAdviceId} id={item.Id} />
        </AccordionTab>
      )
    })
  }

  return (
    <>
      <h3>
        {t('deliveryForecastDespatchAdvice.title.send.dialog.shedules.title')}
      </h3>

      {isItemInitial(deliveryForecastDespatchAdviceItems) && (
        <Message
          className="mb-3"
          text={t(
            'deliveryForecastDespatchAdvice.title.send.dialog.shedules.message',
          )}
        />
      )}

      <Accordion activeIndex={0}>{createDynamicTabs()}</Accordion>
    </>
  )
}
